/*
  ST 2026-09-28 (Wrike 4543052992): Weekly Deal pilot.
  1. Variant change: swap #WeeklyDeal-<section>-<product> from the re-rendered section HTML
     (same pattern as snippets/price-30d-low.liquid; the Concept ProductInfo only updates its own ids).
  2. Round 11: the sticky bar's "X sparen" line is kept in sync by ProductStickyForm.renderPrice (theme.js).
  3. Round 6: box countdown "03 T · 05 Std · 49 Min" ([data-st-deal-countdown], server-rendered
     first paint), refreshed every 30 s from data-end (unix seconds) and data-format ([d] [h] [m]).
  4. Round 14: [data-st-deal-end-hide] (chip and countdown of the Refurbished deal card) hide once data-end
     has passed; the card keeps its 204 px.
  5. Wrike 4579312355: tap toggle for the (i) tooltip in the deal box (.st-deal-tip).
  Loaded only when section.settings.st_weekly_deal is on. Rollback: setting off.
*/
(function () {
  if (window.__stWeeklyDealBound) return;
  window.__stWeeklyDealBound = true;

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function tickCountdowns() {
    var now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-st-deal-countdown]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-end'), 10);
      var format = el.getAttribute('data-format');
      if (!end || !format) return;
      var mins = Math.max(0, Math.floor((end - now) / 60));
      var text = format
        .replace('[d]', pad(Math.floor(mins / 1440)))
        .replace('[h]', pad(Math.floor((mins % 1440) / 60)))
        .replace('[m]', pad(mins % 60));
      if (el.textContent !== text) el.textContent = text;
    });
    document.querySelectorAll('[data-st-deal-end-hide]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-end'), 10);
      if (end && end <= now && !el.hidden) el.hidden = true;
    });
  }

  var tries = 0;
  function bindVariant() {
    if (!(window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS)) {
      if (++tries > 25) return;
      return setTimeout(bindVariant, 200);
    }
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (payload) {
      // publish() has no try/catch: a throw here would break the other handlers.
      try {
        var d = payload && payload.data;
        if (!d || !d.parsedHTML) return;
        var id = 'WeeklyDeal-' + d.sectionId + '-' + d.productId;
        var src = d.parsedHTML.querySelector('#' + id);
        var dst = document.getElementById(id);
        if (src && dst && dst.innerHTML !== src.innerHTML) dst.innerHTML = src.innerHTML;
        tickCountdowns();
      } catch (e) {
        /* ignore */
      }
    });
  }

  // Wrike 4579312355: (i) tooltip next to "Kein Code nötig". Delegated, so it survives the variant swap above.
  // Tap/click toggles it; a click elsewhere or Escape closes it.
  function closeTips(except) {
    document.querySelectorAll('.st-deal-tip.is-open').forEach(function (tip) {
      if (tip === except) return;
      tip.classList.remove('is-open');
      var btn = tip.querySelector('[data-st-deal-tip]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-st-deal-tip]');
    if (!btn) return closeTips(null);
    var tip = btn.closest('.st-deal-tip');
    var open = !tip.classList.contains('is-open');
    closeTips(tip);
    tip.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeTips(null);
  });

  tickCountdowns();
  setInterval(tickCountdowns, 30000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindVariant, { once: true });
  } else {
    bindVariant();
  }
})();
